import { SchoolView } from "./SchoolView";
import { FC } from "react";

export const SchoolViewContainer: FC = () => {
  return <SchoolView />;
};
